import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ContentLoader } from '@saucelabs/sl-component-loader';

import * as operations from './../ducks/operations';
import LogoContentWrapper from './../components/LogoContentWrapper';

class RootContainer extends PureComponent {
  componentDidMount() {
    const { initialize } = this.props;

    initialize(null, { skipErrorPage: true });
  }

  render() {
    const { children, loading } = this.props;

    return (
      <ContentLoader show={loading}>
        <Helmet
          defaultTitle="Sauce Labs"
          titleTemplate="Sauce Labs | %s"
        />
        <LogoContentWrapper>
          {children}
        </LogoContentWrapper>
      </ContentLoader>
    );
  }
}

RootContainer.propTypes = {
  children: PropTypes.node.isRequired,
  initialize: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ apps: { auth } }) => ({
  loading: auth.get('loading'),
});

const mapDispatchToProps = {
  initialize: operations.initialize,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RootContainer));
export {
  RootContainer,
  mapDispatchToProps,
};
